// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-wrap[data-v-45a55f94]{display:flex;align-items:center;height:100%;cursor:pointer}.logo[data-v-45a55f94]{width:97px;height:36px}.link[data-v-45a55f94]{text-decoration:none;color:#fff}", ""]);
// Exports
module.exports = exports;
